import React from 'react';
import { Spacing } from 'works/legacy/lib/style-helper';
import { ComplianceItemStatusIcon } from '@onboarding/components';
import { WorksListItemStateType } from '@onboarding/graphql';

const STATE_MAP = [
  { key: 'rejected', title: 'Rejected' },
  { key: 'approved', title: 'Approved' },
  { key: 'submitted', title: 'Pending Verification' },
  { key: 'pending', title: 'Pending Upload' },
  { key: 'inactive', title: 'Inactive' },
];

export function ComplianceStateLegend() {
  return (
    <>
      <ul className="compliance-state-legend">
        {STATE_MAP.map((stateEntry) => {
          return (
            <li key={stateEntry.key}>
              <ComplianceItemStatusIcon
                status={stateEntry.key as WorksListItemStateType}
              />
              <span className="compliance-state-legend--label">
                {stateEntry.title}
              </span>
            </li>
          );
        })}
      </ul>

      <style jsx>{`
        .compliance-state-legend {
          display: flex;
          align-items: center;
          flex-grow: 1;
          padding: ${Spacing.baseSpacing / 2}px 0;
          list-style: none;
          margin: 0;
        }
        .compliance-state-legend > li:not(:last-child) {
          margin-right: ${Spacing.baseSpacingPx};
        }
        .compliance-state-legend--label {
          margin-left: 8px;
        }
      `}</style>
    </>
  );
}
